// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"4989":"aec26f65cb55e3d630da","9249":"e2b45d30f2ab8515cd23"}[chunkId] + ".chunk.js";
};